<app-health-icon class="status-health-icon" [healthValue]="healthValue"></app-health-icon>
<span>{{ displayStatus | translate }}</span>
